<template lang="">
	<div>
		<v-card class="d-flex pa-5 mb-8 justify-space-around ">
      <div class="d-flex flex-row justify-space-around">
        <v-select
          v-model="selected"
          placeholder="Produto"
          class="mr-5 responsiveMessage h-48 d-flex align-center b-4"
          :options="productsList"
        />
        <input
          v-model="search_text"
          type="text"
          placeholder="Mensagem"
          class="responsiveMessage h-48 mr-5 d-flex b-4 pl-2"
        >
        <v-select
          v-model="status"
          placeholder="Status"
          class="b-4 mr-5 responsiveMessage h-48 d-flex"
          :options="options"
         
        />  
      </div>
      <span width="280px"></span>
			<div class="button-wrapper d-flex justify-space-between">
				<v-btn
					@click="filterList"
          :style="disabled ? 'background: var(--grey-day-030)' : 'background: var(--red)'"
          :disabled="disabled"
          outlined
          height="48"
          class="d-flex align-center mr-5"
          :class="disabled ? 'b-4' : 'b-red'"
          width="120"
				>
					<clip-loader
						v-if="loading"
						:loading="loading"
						color="var(--white)"
						size="22px"
					/>
					<div
            v-if="!loading"
						class="button-wrapper--text d-flex align-center justify-space-around"
						>
						<img class="pr-2" src="../../../../static/images/search.svg">
						<span style="color: var(--white)">Buscar</span>
					</div>
				</v-btn>
				<v-btn
					@click="clearForm"
          style="background: var(--white); color: var(--dark-grey)"
          outlined
          height="48"
          class="d-flex align-center b-clear"
          width="120"
				>
					<clip-loader
						v-if="loadingClear"
						:loading="loadingClear"
						color="var(--black)"
						size="22px"
					/>
					<div
            v-if="!loadingClear"
						class="button-wrapper--text d-flex align-center"
						>
						<img class="pr-2" src="../../../../static/images/load.svg">
						Limpar
					</div>
				</v-btn>
			</div>
		</v-card>
	</div>
</template>
<script>
// Lib
import { mapActions, mapMutations, mapState } from 'vuex'
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

import VueCookies from 'vue-cookies'

export default {
	components: {
		ClipLoader
	},
  data() {
    return {
      selected: '',
      status: null,
      disabled: true,
      search_text: '',
      options: [
        {
          value: 'true',
          text: 'Ativo',
					label: 'Ativo'
        },
        {
          value: 'false',
          text: 'Inativo',
          label: 'Inativo'
        }
      ],
    }
  },
  created() {
    this.status = null
    this.selected = ''
  },
  computed: {
    ...mapState('Product', {
      productItems: 'items',
      loading: 'loading',
      loadingClear: 'loadingClear'
    }),
    ...mapState('Communication', {
      loading: 'loading'
    }),
    productsList () {
      const products = this.productItems.data ? this.productItems.data : []
      return products.map(product =>( {
        value: product.product_id,
        label: product.product_name
      }))
    },
    widthScreen () {
      return screen.width < 1377
    }
  },
  methods: {
    ...mapActions('Communication', [
      'getCommunications'
    ]),
    ...mapActions('Product', [
      'getProducts'
    ]),
    ...mapMutations('Communication', {
      setLoading: 'SET_LOADING',
      setStatusFilter: 'SET_STATUS_FILTER',
      setProductFilter: 'SET_PRODUCT_FILTER',
      setSearchTextFilter: 'SET_SEARCH_TEXT_FILTER',
      setPage: 'SET_PAGE'
    }),
    ...mapMutations('Product', {
      setLoadingClear: 'SET_LOADING_CLEAR',
    }),
    async filterList () {
      this.disabled = true
      this.setLoading(true)
      this.setPage(0)
      if (this.status !== null) {
        this.setStatusFilter(this.status.value)
        this.setProductFilter('')
      } else {
        this.setStatusFilter(null)
      }
      if (this.selected !== '') {
        this.setProductFilter(this.selected.value)
        this.setStatusFilter(null)
      } else {
        this.setProductFilter('')
      }
      if (this.status !== null && this.selected !== '') {
        this.setStatusFilter(this.status.value)
        this.setProductFilter(this.selected.value)
      }
      this.setSearchTextFilter(this.search_text)
      const token = VueCookies.get('jwt-login')
      try {
        await this.getProducts({token: token})
        await this.getCommunications({token: token})
        this.setLoading(false)
      } catch (error) {
        return error
      }
    },
    async clearForm() {
      this.setLoadingClear(true)
      const token = VueCookies.get('jwt-login')
      this.status = null
      this.selected = ''
      this.search_text = ''
      this.setStatusFilter(null)
      this.setProductFilter('')
      this.setSearchTextFilter('')
      await this.getCommunications({token: token})
      this.setLoadingClear(false)
      this.setLoading(false)
    }
  },
  watch: {
    'status' () {
      this.status !== null || this.selected !== null ? this.disabled = false : this.disabled = true
    },
    'selected' () {
      this.status !== null || this.selected !== null ? this.disabled = false : this.disabled = true
    },
    'search_text' () {
      this.search_text !== null || this.selected !== null ? this.disabled = false : this.disabled = true
    }
  }
}
</script>

<style lang="scss">
.vs__selected-options {
  flex-wrap: nowrap;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 250px;
  padding-right: 2px;
  max-width: 100%;
}

.vs__dropdown-toggle {
  width: 100%;
}

.b-4 {
	border: 2px solid var(--grey-day-030) !important;
	border-radius: 4px;
}

.b-red {
	border: 2px solid var(--red) !important;
	border-radius: 4px;
}

.h-48 {
  height: 48px
}

.vs__search {
	display: flex;
  align-items: center;
  // padding: 7px;
  color: #7d7d7d
}

.responsiveMessage {
  width: 291px;
}

.vs__selected-options {
  flex-wrap: nowrap !important;
}

@media screen and (max-width: 1377px) {
  .responsiveMessage {
    width: 158px;
  }
  .vs__selected-options {
    flex-wrap: nowrap !important;
    display: flex;
    justify-content: flex-start;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 180px;
    padding-right: 2px;
    max-width: 100%;
  }

  .vs__selected {
    padding-left: 5px
  }

  .vs__dropdown-toggle {
    width: 100%;
  }

  // .vs__selected-options {
  //   width: 130px;
  //   // padding-right: 20px;
  // }

  // .vs__selected {
  //   width: auto
  // }

  .vs__actions {
    .vs__clear {
      display: none;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/Contents/AutomaticsTriggers/CommunicationFilter.vue